import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon } from '@material-ui/core';
import { updateCustomerPushCartApi } from 'api';
import QuoteSeriesNameModal from './QuoteSeriesNameModal';


const QuoteSeriesName = ({name, seriesId}) => {
  const dispatch = useDispatch();
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const {
    quotePlan,
    customerPushCart,
    currentQuoteCustomer
  } = useSelector((state: IReduxState) => state.quote);
  const { _id: pushCartId } = customerPushCart;

  const handleSaveName = async (newName) => {
    const updatedQuotePlan = quotePlan.map((series) => series._id === seriesId ? {...series, name: newName} : series);
    const updatedPushCart = {...customerPushCart, customer: currentQuoteCustomer, treatments: updatedQuotePlan };
    await updateCustomerPushCartApi({ dispatch, pushCartId, pushCart: updatedPushCart });
    setOpenEditModal(false);
  };

  return (
    <div className="flex">
      <div className="pt-2 font-bold text-16">
        {name}
      </div>
      <Button
        className="ml-3 mt-1 flex items-center"
        size="small"
        onClick={() => setOpenEditModal(true)}
      >
        <Icon fontSize="small" className="mr-1">edit</Icon>
        {'Edit'}
      </Button>
      {openEditModal &&
        <QuoteSeriesNameModal
          open={openEditModal}
          setOpen={setOpenEditModal}
          title="Edit Name"
          defaultValue={name}
          onSave={handleSaveName}
        />
      }
    </div>
  );
};

export default QuoteSeriesName;
